import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ColorPicker from '../../ColorPicker'
import { Button, Card, CardContent, Checkbox, FormControlLabel, FormHelperText, Grid, List } from '@material-ui/core';
import { themeActions } from '../../../_actions/theme.actions';
import DragAndDropProvider from '../../../_helpers/DragAndDropProvider';
import MenuItemCard from '../../MenuItemCard';
import update from 'immutability-helper';
import _ from 'lodash';
import DraggableElement from '../../../_helpers/DraggableElement';
import { SCREEN_OPTIONS } from '../../../_helpers/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { previewerNavigationActions } from '../../../_actions/previewerNavigation.actions';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
  contentTitle: {
    padding: '10px 15px'
  },
  formControl: {
    marginBottom: theme.spacing(3),
  },
  button: {
    margin: '10px 0 20px 0',
  },
  noOptions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '78vh',
    padding: 20,
  },
  noOptionsIcon: {
    color: '#a5a5a5'
  },
  noOptionsText: {
    textAlign: 'center',
    fontWeight: '600',
    color: '#a5a5a5'
  }
}));

export default function TabBar({ data }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const theme = useSelector(state => state.ThemeReducer);
  const isWebviewTheme = theme.key == 'webview';

  const handleChange = (property, value) => {
    let newData = JSON.parse(JSON.stringify(data));
    _.set(newData, property, value)
    dispatch(themeActions.setSelectedSection(newData));
  }

  const toogleMenuItemVisibility = (menuItemIndex) => {
    let newData = JSON.parse(JSON.stringify(data));
    newData.content[menuItemIndex].isVisible = !newData.content[menuItemIndex].isVisible;
    dispatch(themeActions.setSelectedSection(newData));
  }

  const handleMenuItemMove = (dragIndex, hoverIndex) => {
    let contentCopy = JSON.parse(JSON.stringify(data.content));
    const dragSection = contentCopy[dragIndex];

    contentCopy =
      update(contentCopy, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragSection],
        ],
      })

    dispatch(themeActions.setSelectedSection({...data, content: contentCopy}));
  }

  const handleMenuItemChange = (values, menuItemIndex, menuItemKey) => {
    let newData = JSON.parse(JSON.stringify(data));

    for(const item of values){
      _.set(newData, `content[${menuItemIndex}][${item.property}]`, item.value)

      const object = _.find(SCREEN_OPTIONS, { key: menuItemKey });
  
      if(object){
        const keys = Object.keys(object);
        for(const key of keys){
          _.set(newData, `content[${menuItemIndex}][${key}]`, object[key])
        }
      }

      switch(item.value){
        case 'goToCategory':
          _.set(newData, `content[${menuItemIndex}][link]`, 'CategoryStack')
          _.set(newData, `content[${menuItemIndex}][relatedScreens]`, null)
          _.set(newData, `content[${menuItemIndex}][key]`, "")
          break;
        case 'goToProduct':
          _.set(newData, `content[${menuItemIndex}][link]`, 'ProductStack')
          _.set(newData, `content[${menuItemIndex}][relatedScreens]`, null)
          _.set(newData, `content[${menuItemIndex}][key]`, "")
          break;
        case 'goToWebview':
          _.set(newData, `content[${menuItemIndex}][link]`, 'WebViewStack')
          _.set(newData, `content[${menuItemIndex}][relatedScreens]`, null)
          _.set(newData, `content[${menuItemIndex}][key]`, "")
          break;
        case 'goToScreen': {
          const screen = isWebviewTheme
            ? _.find(SCREEN_OPTIONS, { key: 'notification' })
            : SCREEN_OPTIONS[0];
          _.set(newData, `content[${menuItemIndex}][link]`, screen.link)
          _.set(newData, `content[${menuItemIndex}][key]`, screen.key)
          _.set(newData, `content[${menuItemIndex}][relatedScreens]`, screen.relatedScreens)
          break;
        }
        default:
          break;
      }
    }

    dispatch(themeActions.setSelectedSection(newData));
  }

  const handleMenuItemScreenChange = (key, menuItemIndex) => {
    let newData = JSON.parse(JSON.stringify(data));

    const object = _.find(SCREEN_OPTIONS, { key: key });

    if(object){
      const keys = Object.keys(object);
      for(const key of keys){
        _.set(newData, `content[${menuItemIndex}][${key}]`, object[key])
      }
      
      dispatch(themeActions.setSelectedSection(newData));
    }
  }

  const handleMenuItemIconChange = (icon, menuItemIndex) => {
    let newData = JSON.parse(JSON.stringify(data));

    if(icon){
      _.set(newData, `content[${menuItemIndex}][icon][name]`, icon.name)
      _.set(newData, `content[${menuItemIndex}][icon][style]`, icon.style)

      dispatch(themeActions.setSelectedSection(newData));
    }
  }

  const handleMenuItemDelete = (menuItemIndex) => {
    let newData = JSON.parse(JSON.stringify(data));

    const newContent = newData.content.filter((item, index) => index != menuItemIndex)

    _.set(newData, `content`, newContent)

    dispatch(themeActions.setSelectedSection(newData));
  }

  const handleMenuItemAdd = () => {
    let newData = JSON.parse(JSON.stringify(data));

    const screen = SCREEN_OPTIONS[newData.content.length];

    const newContent = { 
      title: 'Novo item', 
      isVisible: true, 
      action: isWebviewTheme ? 'goToWebview' : 'goToScreen', 
      link: isWebviewTheme ? 'WebViewStack' : screen.link, 
      icon: {
        name: 'circle',
        style: 'fas'
      },
      key: isWebviewTheme ? '' : screen.key,
      relatedScreens: isWebviewTheme ? '' : screen.relatedScreens,
    }

    _.set(newData, `content`, [...newData.content, {...newContent}])
    
    dispatch(themeActions.setSelectedSection(newData));
  }
  
  return (
    <main className={classes.content}>
        <Typography variant="overline" display="block" className={classes.contentTitle}>
            Configurações
        </Typography>
        
        <Card elevation={1} square>
          <CardContent>
            <FormControlLabel
              control={
                  <Checkbox
                    checked={_.isNil(data.options.isVisible) ? false : data.options.isVisible}
                    onChange={() => handleChange('options.isVisible', !data.options.isVisible)} 
                    name="isVisible"
                    color="primary"
                  />
              }
              label="Exibir menu inferior"
            />

            {isWebviewTheme && (
              <>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={_.isNil(data.options.showNavigation) ? false : data.options.showNavigation}
                      onChange={() => handleChange('options.showNavigation', !data.options.showNavigation)}
                      name="isVisible"
                      color="primary"
                    />
                  }
                  label="Exibir botões de navegação"
                />
                <FormHelperText >
                  Exibe botões de voltar e avançar no menu inferior da versão iOS. Alguns itens de menu podem ser ocultados para permitir a exibição destes botões.
                  {data.options.showNavigation && (
                    <Typography
                      style={{cursor: 'pointer', fontSize: 12, textDecoration: 'underline'}}
                      onMouseEnter={() => dispatch(previewerNavigationActions.setShowNavigationLayout(true))}
                      onMouseLeave={() => dispatch(previewerNavigationActions.setShowNavigationLayout(false))}>
                      Passe o mouse aqui para visualizar os botões de navegação.
                    </Typography>
                  )}
                </FormHelperText>
              </>
            )}

            {data.options.isVisible &&
              <>
                <ColorPicker 
                  label='Cor de fundo' 
                  initialColor={data.options.backgroundColor} 
                  onChange={(color) => handleChange('options.backgroundColor', color)} 
                />

                <ColorPicker 
                  label='Cor do ícone selecionado' 
                  initialColor={data.options.activeIconColor} 
                  onChange={(color) => handleChange('options.activeIconColor', color)} 
                />

                <ColorPicker 
                  label='Cor do ícone não selecionado' 
                  initialColor={data.options.iconColor} 
                  onChange={(color) => handleChange('options.iconColor', color)} 
                />
              </>
            }
          </CardContent>
        </Card>


        
        {data.options.isVisible ?
          <>
            <Typography variant="overline" display="block" className={classes.contentTitle}>
              Conteúdo
            </Typography>

            <List>
              <DragAndDropProvider>
                {data.content.map((menuItem, index) => (
                  <DraggableElement hoverIndex={index} key={`mic-${index}`} onMove={handleMenuItemMove}>
                    <MenuItemCard 
                      first={index === 0}
                      menuItem={menuItem}
                      menuItemIndex={index}
                      onVisibilityToogle={() => toogleMenuItemVisibility(index)}
                      onChange={handleMenuItemChange}
                      onChangeMenuItemScreen={handleMenuItemScreenChange}
                      onChangeIcon={handleMenuItemIconChange}
                      onDelete={handleMenuItemDelete}
                    />
                  </DraggableElement>
                ))}
              </DragAndDropProvider>
            </List>

            <Grid container justifyContent="center">
              <Button
                color="default"
                className={classes.button}
                onClick={() => handleMenuItemAdd()}
                startIcon={<FontAwesomeIcon icon={['fas', 'plus-circle']} />}
                variant="contained"
                disabled={data.content.length >= 6 ? true : false}
              >
                Adicionar item de menu
              </Button>
            </Grid>
          </>
          : <div className={classes.noOptions}>
            <FontAwesomeIcon icon={['fas', 'info-circle']} size='2x' className={classes.noOptionsIcon} />
            <p className={classes.noOptionsText}>
              Ative o menu inferior para explorar as opções de customização.
            </p>
          </div>
        }

    </main>
  );
}